import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {CountriesService} from '../../../services/countries.service';
import {MessageService} from '../../../../shared/services/message.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-upload-population',
  templateUrl: './upload-population.component.html',
  styleUrls: ['./upload-population.component.scss']
})
export class UploadPopulationComponent implements OnInit {

  uploadExplanation = 'Here you can upload countries population data to update the System information.' +
    ' The Excel document to upload has to have only one sheet, and have the following columns ordered as this:';
  uploadWarningExplanation = 'Keep in mind that the information uploaded will update the system information.' +
    ' Because of that, if you upload wrong information for a country and year, it will be updated.' +
    ' You always can update it again by uploading again information for that specific country and year.' +
    ' It is not necessary for the file to have the data for all the years at every upload, the data contained in the file will simply be created or updated ';
  file!: File;
  fileExtension!: string;
  accept = '.xls,.xlsx';
  exampleFileDataSource = [
    {code: 'AT', year: 2010, population: 8901064},
    {code: 'BE', year: 2010, population: 11549888},
    {code: 'ES', year: 2010, population: 46667174},
  ];
  displayedColumnsExampleFile: string[] = ['code', 'year', 'population'];
  fileForm = this.formBuilder.group({
    file: []
  });

  get fileControl(): FormControl {
    return this.fileForm.get('file') as FormControl;
  }

  constructor(private formBuilder: FormBuilder,
              private readonly router: Router,
              private readonly countryService: CountriesService,
              private messageService: MessageService) { }

  ngOnInit(): void {

  }

  uploadFile(): void {
    this.file = this.fileControl.value;
    this.countryService.uploadPopulation(this.file).subscribe(
      () => {
        const url = this.router.url;
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(
          () => this.router.navigate([url]).then(
            () => this.messageService.showMessage('Saved successfully', 'success')
          )
        );
      }
    );
  }

  getExtension(): void {
    this.file = this.fileControl.value;
    const fileName = this.file.name.split('.');
    this.fileExtension = fileName[fileName.length - 1];
  }

}
